import { createAction } from "redux-starter-kit";
import {
  LOGIN_PAGE_START_LOADING,
  LOGIN_PAGE_LOGIN_SUCCESS,
  LOGIN_PAGE_LOGIN_FAIL
} from "../actionTypes";
import { loginApi } from "../../api/auth";
import { removeAllCookies } from "../../utils/utils";

export const startLoadingAction = createAction(LOGIN_PAGE_START_LOADING);
export const loginSuccessAction = createAction(LOGIN_PAGE_LOGIN_SUCCESS);
export const loginFailAction = createAction(LOGIN_PAGE_LOGIN_FAIL);

export function signInRequestAction(cookies, history) {
  return dispatch => {
    dispatch(startLoadingAction());

    return loginApi().then(
      data => {
        const { id, fb_uid, role } = data;

        cookies.set("id", id, { path: "/", maxAge: 31536000 });
        cookies.set("fb_uid", fb_uid, { path: "/", maxAge: 31536000 });
        cookies.set("role", role, { path: "/", maxAge: 31536000 });

        dispatch(loginSuccessAction());
        history.push(process.env.REACT_APP_URL_ROOT);
      },
      err => {
        removeAllCookies();
        cookies.remove("id", { path: "/" });
        cookies.remove("fb_uid", { path: "/" });
        cookies.remove("role", { path: "/" });
        cookies.remove("fbsr_" + process.env.REACT_APP_FB_APP_ID, {
          path: "/"
        });
        cookies.remove("fbm_" + process.env.REACT_APP_FB_APP_ID, { path: "/" });
        cookies.remove("fbsr_" + process.env.REACT_APP_FB_APP_ID);
        cookies.remove("fbm_" + process.env.REACT_APP_FB_APP_ID);

        dispatch(loginFailAction({ errMsg: err.toString() }));
      }
    );
  };
}
